/**
 * @generated SignedSource<<9e40ec9c78efd40ba1ef11a60a4dd9d6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type backofficeUiPreferencesSaveMutation$variables = {
  data: string;
};
export type backofficeUiPreferencesSaveMutation$data = {
  readonly createOrUpdateBackofficeUiPreference: {
    readonly __typename: "BackofficeUiPreferenceApiDto";
  } | null;
};
export type backofficeUiPreferencesSaveMutation = {
  response: backofficeUiPreferencesSaveMutation$data;
  variables: backofficeUiPreferencesSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "BackofficeUiPreferenceApiDto",
    "kind": "LinkedField",
    "name": "createOrUpdateBackofficeUiPreference",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "backofficeUiPreferencesSaveMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "backofficeUiPreferencesSaveMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "9e6464a1955e25e81f0b8a37e36667a9",
    "id": null,
    "metadata": {},
    "name": "backofficeUiPreferencesSaveMutation",
    "operationKind": "mutation",
    "text": "mutation backofficeUiPreferencesSaveMutation(\n  $data: String!\n) {\n  createOrUpdateBackofficeUiPreference(data: $data) {\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a494b2179de61639c88c8b15d90f9d3";

export default node;
